import { routes } from '$src/routes';

export default function Honeypot() {
  return (
    <a href={routes.honeypot} rel="nofollow" style={{ display: 'none' }} aria-hidden="true">
      sign in
    </a>
  );
}
